import { TerritoryStatus } from '@/types/territories/territory.status.type';

/**
 * Internal (franchisor + consultant) display labels for territory statuses.
 * Statuses not listed here fall back to Capitalized form (e.g. "Available").
 *
 * NOTE: this is the INTERNAL presentation. External surfaces (ZEE, public
 * pages, embeds, SEO, PDFs) must never see RESELL — it is normalized to
 * AVAILABLE at the `ff-backend-territories` service boundary, so it never
 * reaches those consumers as "Territory Resell".
 */
export const TERRITORY_STATUS_LABELS: Partial<Record<TerritoryStatus, string>> =
  {
    RESELL: 'Resell',
  };

export const getTerritoryStatusLabel = (status: TerritoryStatus): string =>
  TERRITORY_STATUS_LABELS[status] ??
  status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
